import type { ReactNode } from 'react'

import type { Tag } from './tagging.types'
import { TaggingContext } from './TaggingProvider'
import { useRentalTagging } from './useRentalTagging'

interface RentalTagsProviderProps {
  children: ReactNode
  refetch: () => Promise<void>
  rentalId: string
  rentalTags: Tag[]
}

export const RentalTagsProvider = (props: RentalTagsProviderProps) => {
  const { children, refetch, rentalId, rentalTags } = props
  const hook = useRentalTagging({ refetch, rentalId, rentalTags })

  return (
    <TaggingContext.Provider value={hook}>{children}</TaggingContext.Provider>
  )
}
